<template>
    <BaseCard
        as="button"
        type="button"
        padding="none"
        radius="lgr"
        class="walkthrough-video-card overflow-hidden text-left"
        :aria-label="t('chat.tutorial.videoCardLabel', { title: video.title, duration: formatDuration(video.durationSeconds) })"
        @click="emit('select')">
        <div class="relative">
            <img :src="video.poster" alt="" class="aspect-video w-full object-cover" />
            <div class="absolute inset-x-0 bottom-0 flex items-end justify-between bg-gradient-to-t from-ink/90 via-ink/35 to-transparent px-3 pb-3 pt-10" aria-hidden="true">
                <span class="tutorial-video-play-indicator flex size-8 items-center justify-center rounded-full text-ink-inverse transition-colors duration-150">
                    <i class="bi bi-play-fill text-[12px]" aria-hidden="true"></i>
                </span>
                <span class="rounded-full bg-ink px-2 py-1 body-small-semibold text-ink-inverse">{{ formatDuration(video.durationSeconds) }}</span>
            </div>
        </div>
    </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import { useI18n } from "vue-i18n";

import { formatDuration, type TutorialVideo } from "./walkthroughVideos";

defineProps<{ video: TutorialVideo }>();
const emit = defineEmits<{ select: [] }>();
const { t } = useI18n();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .walkthrough-video-card {
        transition:
            translate 150ms ease,
            box-shadow 150ms ease;
    }

    .walkthrough-video-card:hover {
        translate: 0 -0.125rem;
        @apply shadow-sm;
    }

    .tutorial-video-play-indicator {
        @apply bg-ink;
    }

    .walkthrough-video-card:hover .tutorial-video-play-indicator {
        @apply bg-valence-accent;
    }

    @media (prefers-reduced-motion: reduce) {
        .walkthrough-video-card {
            transition: none;
        }

        .walkthrough-video-card:hover {
            translate: none;
        }
    }
}
</style>
